/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Agent_Development_Tools_Desc5Inputs */

const en_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything your business already uses becomes an agent "tool", CRMs, databases, internal APIs, email, and file systems.`)
};

const ar_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كل ما تستخدمه شركتك بالفعل يصبح «أداة» للوكيل, أنظمة علاقات العملاء وقواعد البيانات والواجهات البرمجية الداخلية والبريد الإلكتروني وأنظمة الملفات.`)
};

const bn_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার ব্যবসায় ইতিমধ্যে ব্যবহৃত সবকিছুই এজেন্টের "টুল" হয়ে যায়, CRM, ডেটাবেস, ইন্টারনাল API, ইমেইল, ফাইল সিস্টেম।`)
};

const de_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles, was Ihr Unternehmen bereits nutzt, wird zum Agenten-Tool: CRMs, Datenbanken, interne APIs, E-Mails und Dateisysteme.`)
};

const es_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo lo que su empresa ya utiliza se convierte en una "herramienta" de agente, CRM, bases de datos, API internas, correo electrónico y sistemas de archivos.`)
};

const fr_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ce que votre entreprise utilise déjà devient un « outil » d'agent : CRM, bases de données, API internes, courrier électronique et systèmes de fichiers.`)
};

const pt_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo o que sua empresa já usa se torna uma "ferramenta" de agente, CRMs, bancos de dados, APIs internas, e-mail e sistemas de arquivos.`)
};

const zh_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的企业已使用的所有内容都将成为代理“工具”、CRM、数据库、内部 API、电子邮件和文件系统。`)
};

const tr_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşletmenizin zaten kullandığı her şey ajan için bir 'araç' olur, CRM'ler, veritabanları, dahili API'ler, e-posta ve dosya sistemleri.`)
};

const ru_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все, что ваш бизнес уже использует, становится «инструментом» агента: CRM, базы данных, внутренние API, электронная почта и файловые системы.`)
};

const pl_svc_ai_agent_development_tools_desc5 = /** @type {(inputs: Svc_Ai_Agent_Development_Tools_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystko, czego już używa Twoja firma, staje się „narzędziem” agenta, systemami CRM, bazami danych, wewnętrznymi interfejsami API, pocztą elektroniczną i systemami plików.`)
};

/**
* | output |
* | --- |
* | "Everything your business already uses becomes an agent \"tool\", CRMs, databases, internal APIs, email, and file systems." |
*
* @param {Svc_Ai_Agent_Development_Tools_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_agent_development_tools_desc5 = /** @type {((inputs?: Svc_Ai_Agent_Development_Tools_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Agent_Development_Tools_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "bn") return bn_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "de") return de_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "es") return es_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "fr") return fr_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "pt") return pt_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "zh") return zh_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "tr") return tr_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "ru") return ru_svc_ai_agent_development_tools_desc5(inputs)
	if (locale === "pl") return pl_svc_ai_agent_development_tools_desc5(inputs)
	return en_svc_ai_agent_development_tools_desc5(inputs)
});
export { svc_ai_agent_development_tools_desc5 as "svc_ai-agent-development_TOOLS_desc" }